<template>
  
  <b-card>
    <b-table
      :items="logs"
      :fields="fields"
      striped
      bordered
      small
      responsive
      :busy="busy"
      show-empty
    >
      
      <template #empty>
        <h4 class="text-center text-primary">Nenhum Resultado Encontrado</h4>
      </template>
      
      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Aguarde</strong>
        </div>
      </template>
      
      <template #cell(status)="data">
        <b-badge :variant="data.item.status === 'delivered' ? 'light-success' : 'light-danger'">
          {{ traducaoStatus[data.item.status] }}
        </b-badge>
      </template>
      
      <template #cell(data_click_email)="data">
        <b-badge
          variant="light-success"
          class="cursor-pointer"
          v-if="data.item.data_click_email"
          v-b-tooltip.hover.left
          :title="data.item.data_click_email | converteDataHora"
        >
          Sim
        </b-badge>
        
        <b-badge
          variant="light-danger"
          v-else
        >
          Não
        </b-badge>
      </template>
      
      <template #cell(data_envio)="data">
        {{ data.item.created_at | converteDataHora }}
      </template>
      
    </b-table>
  
  </b-card>

</template>


<script>
import {mapState} from "vuex";
import {BCard, BTable, BBadge, BButton, BSpinner, BRow, BCol, BAlert, VBTooltip} from "bootstrap-vue";
import formataData from "@/mixins/formataData";

export default {
  name: "EmailLogsTabela",
  mixins: [formataData],
  components: {BAlert, BCol, BRow, BSpinner, BButton, BCard, BTable, BBadge},
  directives: {
    'b-tooltip': VBTooltip,
  },
  
  data() {
    return {
      fields: [
        { key: "data_envio", label: 'Data', thStyle: { width: "20px" } },
        { key: "nome", label: 'Mensagem', thStyle: { width: "150px" } },
        { key: "id_company", label: 'Id',  thStyle: { width: "20px" } },
        { key: "empresa", label: 'Nome',  thStyle: { width: "200px" } },
        { key: "empresa_email", label: 'Email',  thStyle: { width: "100px" } },
        { key: "data_click_email", label: 'Click', thStyle: { width: "40px" }  },
        { key: "status", label: 'Status', thStyle: { width: "40px" }  },
      ],
      traducaoStatus: {
        delivered: 'Entregue',
        failed: 'Falhou',
      }
    }
  },
  
  computed: {
    ...mapState({
      logs: state => state.mensagensLogs.logs,
      busy: state => state.mensagensLogs.busy,
    })
  }
  
}
</script>

<style scoped>

</style>
